module.exports = __webpack_public_path__ + "img/solar-panel.f42b4be7.svg";